// Base
import Image from 'next/image'

// Components
import { Box, Text } from 'yard-utilities/components'
import HeaderElement from './elements/HeaderElement'
import FooterElement from './elements/FooterElement'

// Interfaces
import { FooterElementProps } from './elements/FooterElement'
import { HeaderElementProps } from './elements/HeaderElement'

// Styles
import styles from './FacebookReviewCard.module.sass'

interface FacebookReviewCardProps
  extends HeaderElementProps,
    FooterElementProps {
  image?: string
  only?: 'hearts' | 'likes' | string
  children: string | React.ReactNode
}

const FacebookReviewCard = ({
  children,
  comments,
  likes,
  only,
  avatar,
  name,
  reviewPosted,
  image
}: FacebookReviewCardProps) => {
  return (
    <Box
      borderRadius={{ sm: [10] }}
      padding={{ sm: [12, 16] }}
      backgroundColor="white"
      shadow="shadow-75"
    >
      <HeaderElement avatar={avatar} name={name} reviewPosted={reviewPosted} />
      <Text
        tagName="p"
        variant="body-7"
        textColor="black-70"
        fontFamily="segoe"
      >
        {children}
      </Text>
      {image && (
        <Image
          src={image}
          alt="Image attached to comment"
          width={400}
          height={400}
          className={styles.image}
        />
      )}
      <FooterElement comments={comments} likes={likes} only={only} />
    </Box>
  )
}

export default FacebookReviewCard
